import { render, staticRenderFns } from "./delete_project.vue?vue&type=template&id=ebd38286&scoped=true&"
import script from "./delete_project.vue?vue&type=script&lang=js&"
export * from "./delete_project.vue?vue&type=script&lang=js&"
import style0 from "./delete_project.vue?vue&type=style&index=0&id=ebd38286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd38286",
  null
  
)

export default component.exports